import { Grid_List, Grid_Results, Mapped_Results } from '@app/post-lists/grid-list'
import { Week_Filter } from '@app/filter/week-filter'
import { Ctx } from '@app/context'
import ClickEvent = JQuery.ClickEvent;
import { DateTime } from 'luxon'
import { Goehler_Tool_REST_Client } from '@app/utils/rest-client'
import { GT_My_Running_Time } from '../../types/times'
import { handle_api_error } from '@app/utils/api-error'
import { App_Times_Controller } from '@app/controllers/times-controller'

export abstract class Week_Grid_List extends Grid_List {
    type: string = 'grid-list'

    supports_dates: boolean = false
    supports_work: boolean = true
    supports_projects: boolean = true
    supports_week: boolean = true

    week_filter: Week_Filter
    rest_client: Goehler_Tool_REST_Client

    times_controller: App_Times_Controller

    protected constructor( ctx: Ctx ) {
        super( ctx )

        this.week_filter = new Week_Filter( this )

        ctx.filters.week_filter = this.week_filter
        this.week_filter.set_current_week()

        this.rest_client = new Goehler_Tool_REST_Client()
        this.times_controller = new App_Times_Controller()
    }

    public ready() {
        this.init_events()
        this.init_calendars()
        this.times_controller.ready()
    }

    protected init_events() {
        super.init_events()
        jQuery( '.list-week-container button' ).on( 'click', ( e: ClickEvent ) => this.change_current_week( e ) )
    }

    protected init_calendars() {
        jQuery( '[data-list] .selected-week' )
            .calendar(
                {
                    type: 'date',
                    selectAdjacentDays: true,
                    firstDayOfWeek: 1,
                    disabledDaysOfWeek: [ 0, 6 ],
                    showWeekNumbers: true,
                    today: true,
                    monthFirst: false,
                    context: 'body',
                    multiMonth: 3,
                    monthOffset: -1,
                    text: app.calendar_text,
                    popupOptions: {
                        position: 'top center',
                    },

                    // @ts-expect-error Overload
                    onChange: ( date, text, mode ) => {
                        console.debug( 'week onchange', date, text, mode )

                        const monday = DateTime.fromJSDate( date ).startOf( 'week' )

                        this.week_filter.update_current_week( monday )

                        this.clear_results()

                        this.ajax_load_week_posts( monday )
                    }
                }
            )
    }

    protected abstract map_results(): Mapped_Results

    public render_results() {
        console.log( 'render results' )
        this.clear_results()

        if ( ! gt_results.projects.length && ! gt_results.remaining_work.length && ! gt_results.dates.length ) {
            this.show_no_grid_results()
            return
        }

        const results: Mapped_Results = this.map_results!()

        this.render_columns( results )

        void this.render_running_indicators()
    }

    private async render_running_indicators() {
        const TASK = 'Laden der laufenden Arbeitszeiten'

        console.log( 'render indicators' )

        // disable all indicators

        try {
            const response = await this.rest_client.get(
                'goehler-tool/v1/times/load-running-times'
            ) as number[]

            console.log( 'laufende Arbeitszeiten?', response )

            for ( const post_id of response ) {
                this.render_running_indicator( post_id )
            }
        } catch ( error ) {
            handle_api_error( error, TASK )
        }

        try {
            const response = await this.rest_client.get(
                'goehler-tool/v1/times/my-running-times'
            ) as GT_My_Running_Time[]

            console.log( 'eigene Arbeitszeit', response )

            app.times_controller.running_time = response[0] ?? null
            app.times_controller.check_my_running_times()
        } catch ( error ) {
            handle_api_error( error, TASK )
        }
    }

    render_running_indicator( post_id: number ): void {
        const containers = document.querySelectorAll( `.project-item[data-post-id="${post_id}"]` )

        if ( ! containers ) {
            return
        }

        for ( const container of Array.from( containers ) ) {
            container.classList.add( 'active' )
        }
    }

    protected render_column( key: string, results: Grid_Results ) {
        if ( ! results.length ) {
            return
        }

        console.log( 'render column', key, key, results )

        for ( const result of results ) {
            this.render_result( key, result )
        }
    }

    protected abstract ajax_load_week_posts( day: DateTime|null ): void

    protected change_current_week( e: ClickEvent ) {
        console.log( 'change current week', e.currentTarget )

        const trigger: HTMLButtonElement = e.currentTarget
        const offset: number = trigger.classList.contains( 'next-week' ) ? 1 : -1

        this.week_filter.change_current_week( offset )

        this.clear_results()

        const monday = this.week_filter.get_current_week().days.mon

        this.ajax_load_week_posts( monday )
    }

    public reload_results(): void {
        const monday = this.week_filter.get_current_monday()
        this.ajax_load_week_posts( monday )
    }
}
